import { Button, FormGroup, InputLabel, OutlinedInput } from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import {
  Container,
  ContainerForm,
  ContainerFormRight,
  Title,
} from "../../styles/index.sty";
import AlertSnack from "../../components/Alert/AlertSnack";
import { useAuth } from "../../context/authContext";
import { useLists } from "../../context/listContext";
import {
  addSliderImage,
  insertSliderData,
  updateSliderData,
} from "../../api/slider.api";

export const AddSliderImages = () => {
  const { config, config2 } = useAuth();
  const { fetchSliderList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState({});
  const [file, setFile] = useState([]);
  const data = location?.state?.data;
  const formik = useFormik({
    initialValues: {
      slider_name: data?.slider_name,
      slider_sub_heading: data?.slider_sub_heading,
    },
    onSubmit: async (values) => {
      // setLoading(true);
      if (data) {
        const submit = await updateSliderData(
          { ...values, slider_id: data?.slider_id },
          config2
        );
        setResponse(submit);
        setOpen(true);
        fetchSliderList();
        if (submit.status === "success") {
          navigate("/slider");
        }
      } else {
        const submit = await insertSliderData(values, config);
        setResponse(submit);
        console.log("===> this is submit", submit)
        // fetchSliderList();
        // setOpen(true);
        if (submit.status === "success") {
          // navigate("/slider");
          const newFiles = Object.entries(file);
          console.log(newFiles);
          newFiles.forEach(async (el) => {
            console.log(el);
            await addSliderImage(
              { slider_id: submit.data.slider_id, file: el[1] },
              config2
            );
          });
        }
      }
    },
  });
  function handleChange(e) {
    setFile(e.target.files);
  }

  return (
    <>
      <Container>
        <Title variant="h5" className="w-[100%]">
          Enter Slider Details.
        </Title>
        <ContainerForm>
          {open && (
            <AlertSnack
              open={open}
              setOpen={setOpen}
              response={response}
              setLoading={setLoading}
              route="customers"
            />
          )}

          {/* {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        : */}
        <div className="w-[80%] flex flex-wrap m-auto justify-between">
          {
            data['slider-images']?.map(img => {
              return (
                <img
                  className="w-[48%]"
                  key={img.slider_image_id}
                  src={img.image_file}
                  alt={img.image_name}
                />
              )
            })
          }

        </div>
        </ContainerForm>
        <ContainerFormRight>
          <div className="flex items-center column flex-wrap">
            <h2 className="w-100">Select the images and submit</h2>
            <input type="file" multiple onChange={handleChange} />
            {/* <Button
            variant="contained"
            // onClick={handleSubmit}
          >
            Submit
          </Button> */}
            <div className="flex flex-wrap">
              {Array.from(file).map((item, i) => {
                return (
                  <div key={i} className="w-[23%] mr-[2%] flex mt-5">
                    <img
                      className="w-[100%] flex"
                      src={item ? URL.createObjectURL(item) : null}
                      alt=""
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </ContainerFormRight>
      </Container>
    </>
  );
};
